import { Injectable } from '@angular/core';
import { AppConfigService } from './app-config.service';
import { HttpClient, HttpErrorResponse,HttpHeaders} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class BtInsightService {
public textAnalysis;
public textAnalysisClusters;
public trendURL;
  constructor(private http: HttpClient,private textAnalysisURL:AppConfigService) {
    var data = this.textAnalysisURL.getEnvironment();
    this.textAnalysis = data.TextAnalytic+'/WordCloud';
    this.trendURL =data.TextAnalytic+'/Trend';
    this.textAnalysisClusters = data.api.IOMAPIUrl+'/Ticket/GetAutomationMitigation/'
  }
  //public _topLineJsonURL="http://localhost:5009/iom/clustering/";
  

  getTopJSON(id:any): Observable<Object> {   
    var type = {VersionID:id}
    let headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json');
    return this.http.post(this.textAnalysisClusters,type, {
      headers: headers
    })
      .pipe(map((response: Response) => {
        return response;
      }, (error: HttpErrorResponse) => {
        return error
      }));
    }

    getNgramJson(id:any,categoryId:any,subCategory:any,value:any,drill:any="none"): Observable<Object> {  
      const type =new FormData()
      type.append('VersionId',id)
      if(categoryId == undefined ||categoryId ==0){}
      else{ type.append('Category',categoryId)}

      if(subCategory == undefined ||subCategory ==0){}
      else{ type.append('SubCategory',subCategory)}

      if(drill == "none"){}
      else{ type.append('Drill',drill)}

      type.append('wordlen',value)
      let headers = new HttpHeaders();
      headers.set('Content-Type', 'application/json');
      return this.http.post(this.textAnalysis,
        type, {
        headers: headers
      })
        .pipe(map((response: Response) => {
          return response;
        }, (error: HttpErrorResponse) => {
          return error
        }));
      }

      getTrendJson(id:any,categoryId:any,subCategory:any): Observable<Object> {  
        const type =new FormData()
        type.append('VersionId',id)
        if(categoryId == undefined ||categoryId ==0){}
        else{ type.append('Category',categoryId)}

        if(subCategory == undefined ||subCategory ==0){}
        else{ type.append('SubCategory',subCategory)}
  
        let headers = new HttpHeaders();
        headers.set('Content-Type', 'application/json');
        return this.http.post(this.trendURL,
          type, {
          headers: headers
        })
          .pipe(map((response: Response) => {
            return response;
          }, (error: HttpErrorResponse) => {
            return error
          }));
        }

      getClusterJson(value:any): Observable<Object> { 
        const type =new FormData()
        type.append('cluster',value)
        type.append('type','drill')

        let headers = new HttpHeaders();
        headers.set('Content-Type', 'application/json');
        return this.http.post(this.textAnalysis,
          type, {
          headers: headers
        })
          .pipe(map((response: Response) => {
            return response;
          }, (error: HttpErrorResponse) => {
            return error
          }));
        }
}
